/** Product name: written once (sidebar, sign-in screens, tab title). */
export const PRODUCT = "YYS Tracker";
